import ICONS_MAP from "@public/icons/iconsMap.json";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";

export const ICONS = ICONS_MAP.icons as DSIconName[];
